import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

@Injectable({
  providedIn: 'root'
})
export class VoicetestService {

  constructor(private http: HttpClient, private common: CommonService) { }

  private getAuthHeaders() {
      const token = localStorage.getItem('jwtToken');
      return {
        headers: new HttpHeaders({
          'Authorization' : `Bearer ${token}`
        })
      }
    }

  getVoicetest(payload: (string | null) = null) {
    return this.http.get(
      // this.common.getBaseUrl() + 'patients.php?action=PatientsList' + (payload ? '&list=all' : '')
      'https://clinic.tantrata.com/api/prescription', this.getAuthHeaders()
    );
  }

  addVoicetest(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addPatients";
    // return this.http.post(this.common.getBaseUrl() + 'patients.php', payload);
    return this.http.post('https://clinic.tantrata.com/api/prescription', payload, this.getAuthHeaders());
  }

  updateVoicetest(payload: any) {
    payload["action"] = "updatePatients";
    // return this.http.put(this.common.getBaseUrl() + 'patients.php', payload);
    return this.http.put('https://clinic.tantrata.com/api/prescription/' + payload.id, payload, this.getAuthHeaders());
  }

  deleteVoicetest(payload: any) {
    payload["action"] = "deletePatients";
    return this.http.put(this.common.getBaseUrl() + 'patients.php', payload);
  }

  getLatestPrescription(patientId: number) {
    return this.http.get('https://clinic.tantrata.com/api/prescription/latest?patient_id=' + patientId, this.getAuthHeaders());
  }

  getVoicetestByPatientId(patientId: number) {
    return this.http.get('https://clinic.tantrata.com/api/patients/' + patientId + '/prescriptions', this.getAuthHeaders());
  }

  uploadReports(formData: FormData) {
    return this.http.post('https://clinic.tantrata.com/api/reports/upload', formData, this.getAuthHeaders());
  }

  getReportsByPatientId(patientId: number) {
    return this.http.get('https://clinic.tantrata.com/api/reports/patient/' + patientId , this.getAuthHeaders());
  }

}
